import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { X, Heart } from "lucide-react";

const PRESET = [2, 5, 10, 20];

export default function TipDialog({ username, onClose }) {
    const [amount, setAmount] = useState(5);
    const [message, setMessage] = useState("");
    const [busy, setBusy] = useState(false);
    const net = (amount * 0.85).toFixed(2);

    const submit = async () => {
        if (amount < 1) { toast.error("Minimum tip is $1"); return; }
        setBusy(true);
        try {
            const { data } = await api.post("/payments/tip", {
                recipient_username: username,
                amount: Number(amount),
                origin_url: window.location.origin,
                message: message.trim(),
            });
            window.location.href = data.checkout_url;
        } catch (e) {
            toast.error(formatApiError(e));
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-[#0A0A0A]/40 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="tip-dialog-overlay">
            <div className="bg-white brut-lg rounded-xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()} data-testid="tip-dialog">
                <div className="flex items-start justify-between mb-4">
                    <div>
                        <h2 className="display text-2xl font-black flex items-center gap-2">
                            <Heart className="w-5 h-5 fill-[#FF5A5F] text-[#FF5A5F]" /> Tip @{username}
                        </h2>
                        <p className="text-sm text-[#4A4A4A] font-medium">Show some love. Creator gets 85%, platform 15%.</p>
                    </div>
                    <button onClick={onClose} className="p-1" aria-label="Close" data-testid="tip-close"><X className="w-5 h-5" /></button>
                </div>

                <div className="grid grid-cols-4 gap-2 mb-4">
                    {PRESET.map((p) => (
                        <button
                            key={p}
                            onClick={() => setAmount(p)}
                            className={`py-3 rounded-lg border-2 border-[#0A0A0A] font-black ${amount === p ? "bg-[#FFB8D1] shadow-[3px_3px_0px_#0A0A0A]" : "bg-white"}`}
                            data-testid={`tip-preset-${p}`}
                        >
                            ${p}
                        </button>
                    ))}
                </div>

                <label className="text-xs font-bold uppercase tracking-wide">Custom amount (USD)</label>
                <input
                    type="number"
                    min={1}
                    max={200}
                    step={0.5}
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className="w-full mt-1 mb-3 px-4 py-3 rounded-lg brut-inset bg-white font-bold focus:outline-none"
                    data-testid="tip-amount"
                />

                <label className="text-xs font-bold uppercase tracking-wide">Message (optional)</label>
                <input
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={200}
                    placeholder="You've got great toes 👣"
                    className="w-full mt-1 mb-4 px-4 py-3 rounded-lg brut-inset bg-white font-medium focus:outline-none"
                    data-testid="tip-message"
                />

                <div className="text-xs text-[#4A4A4A] font-medium mb-4">
                    They receive <span className="font-black text-[#0A0A0A]">${net}</span>. Payment processed by Stripe.
                </div>

                <button
                    onClick={submit}
                    disabled={busy}
                    className="w-full px-4 py-3 rounded-lg brut bg-[#0A0A0A] text-white font-bold disabled:opacity-50"
                    data-testid="tip-submit"
                >
                    {busy ? "Redirecting…" : `Send $${Number(amount || 0).toFixed(2)} tip`}
                </button>
            </div>
        </div>
    );
}
